<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink } from 'vue-router';

import { useLocalePath } from '@/composables/useLocalePath';
import { initAnalytics } from '@/utils/analytics';
import { COOKIE_CONSENT, hasCookieConsent, setCookie } from '@/utils/cookies';

const { localeRoute } = useLocalePath();

/** Hidden for anyone who has already answered, and for the rest of a dismissal. */
const visible = ref(!hasCookieConsent());

function accept(): void {
  setCookie(COOKIE_CONSENT, new Date().toISOString());
  visible.value = false;
  // Blade only had the request boundary to act on; now the tags go in at once.
  initAnalytics();
}

/**
 * Closing without accepting stores nothing, exactly as before — the banner
 * comes back on the next visit and no tracking is loaded.
 */
function dismiss(): void {
  visible.value = false;
}
</script>

<template>
  <div v-if="visible" class="cookies-container">
    <div class="cookies-wrapper">
      <div class="cookies-confirmation-text">
        <p class="small">
          {{ $t('components.cookies.notification.body') }}
          <span class="privacy-link">
            {{ $t('components.cookies.notification.link_before') }}
            <RouterLink :to="localeRoute('privacy-and-cookie-policy')">
              {{ $t('components.cookies.notification.link') }}
            </RouterLink>
          </span>
        </p>
      </div>
      <div class="cookies-accept-btn-container">
        <button type="button" @click="accept">
          <div class="cookies-accept-btn">
            <p class="btn btn-primary btn-big">
              {{ $t('components.cookies.notification.accept') }}
            </p>
          </div>
        </button>
      </div>
      <div class="cookies-close-btn-container">
        <button type="button" :aria-label="$t('generic.close')" @click="dismiss">
          <div class="cookies-close-btn"></div>
        </button>
      </div>
    </div>
  </div>
</template>
